export default {
  text: {
    order_cancelled: 'Zamówienie anulowane – brak kierowcy',
    wolt_support: 'Pytania? Zadzwoń do Wolt <underline>{{phone_number}}</underline>',
    order_not_confirmed: '<strong>PILNE:</strong> Zaakceptuj lub odrzuć to zamówienie natychmiast',
  },
  labels: {
    dummy_order: 'Zamówienie testowe',
    items_one: '{{count}} pozycja',
    items_few: '{{count}} produkty',
    items_many: '{{count}} produktów',
    items_other: '{{count}} pozycji',
    needs_acceptance: 'Wymaga akceptacji',
    driver_pending: 'Oczekiwanie na kierowcę',
    today: 'Dziś',
    driver_assigned: 'Kierowca przydzielony',
    complete: 'Ukończone',
  },
  buttons: {
    complete_order: 'Oznacz jako ukończone',
    looking_for_driver: 'Szukamy kierowcy...',
    click_to_remove: 'Kliknij, aby usunąć',
  },
};
